import { useCallback, useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { makePost } from "@culturehq/client";

const useGaTracking = () => {
  const [gaClientId, setGaClientId] = useState<string>();
  const [gaSessionId, setGaSessionId] = useState<string>();
  const [referrer, setReferrer] = useState<string>();

  useEffect(() => {
    // Set the referrer only if it is not already set
    if (!referrer && document.referrer) {
      setReferrer(document.referrer);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    ReactGA.ga((tracker: any) => {
      setGaClientId(tracker.get("clientId"));
    });

    const getGaClientCookie = () => {
      const gaClientCookie = document.cookie.match(/_ga=([^;]+)/g);
      let clientId;
      if (gaClientCookie && gaClientCookie.length > 0) {
        const gaCookie = gaClientCookie[0];
        const match = gaCookie.match(/GA[1-2]\.[0-9]+\.(\d+)\.(\d+)/);
        if (match) {
          clientId = `${match[1]}.${match[2]}`;
        }
      }
      return clientId;
    };

    const getGaSessionCookie = () => {
      const cookies = document.cookie.split(";");
      let gaSession;
      for (let i = 0; i < cookies.length; i += 1) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith("_ga_")) {
          // Extract the value from the cookie
          const cookieParts = cookie.split("=");
          const cookieValue = cookieParts[1];
          // Split the value by periods and get the desired part
          const valueParts = cookieValue.split(".");
          // eslint-disable-next-line prefer-destructuring
          gaSession = valueParts[2];
        }
      }
      return gaSession;
    };

    setGaClientId(getGaClientCookie() || "1525141340.1682016225");
    setGaSessionId(getGaSessionCookie());
  }, []);

  const trackEvent = useCallback(async (body: Record<string, any>) => makePost("/stories/track", {
    ...body,
    gaClientId: gaClientId || "",
    gaSessionId: gaSessionId || "",
    referrer: referrer || ""
  }), [gaClientId, gaSessionId, referrer]);

  return { gaClientId, gaSessionId, trackEvent };
};

export default useGaTracking;
